export const apiUrl = function() {
    if (location.hostname === 'localhost') {
        return 'http://localhost:3000/';
    } else {
        return '/';
    }
}();
